<template>
    <div class="auditResult">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="body">
            <div>
                <img :src="url" alt="">
                <div class="result">{{result}}</div>
                <p v-if="+status===40" class="errtips">失败原因：{{errmsg}}</p>
                <span class="tips">请稍后去订单页面查询支付结果</span>
            </div>
            <button @click="onGroupDetail" v-if="(status == 30) && groupParticipationId">查看拼团详情</button>
            <button @click="clickHandle">{{status === '40' ? '重新支付' : '查看订单'}}</button>
            <div class="recommend" v-if="recommendList.length">
                <RecommendGood :recommendData='recommendList[0]' @handleDetail="handleDetail" />
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../common/header'
import { mapActions } from 'vuex'
import { getRecommentd } from '../api/product'
import RecommendGood from './component/recommendGood'
export default {
    name: 'auditResult',
    data () {
        return {
            status: parseInt(this.$route.query.status) || 20,
            spikeId: this.$route.query.spikeId || '',
            errmsg: this.$route.query.errmsg || '',
            groupParticipationId: parseInt(this.$route.query.groupParticipationId) ? this.$route.query.groupParticipationId : 0,
            canPayRetainage: JSON.parse(this.$route.query.canPayRetainage),
            title: '支付结果',
            result: '支付成功',
            successUrl: require('../../../assets/img/b2b/img_right@2x.png'),
            peddingUrl: require('../../../assets/img/b2b/img_wait2.png'),
            failUrl: require('../../../assets/img/b2b/img_wrong.png'),
            url: '',
            activityParams: '',
            recommendList: []
        }
    },
    components: {
        Header,
        RecommendGood
    },
    methods: {
        ...mapActions(['setActivity']),
        onBack () {
            if (this.$route.query.presaleId) {
                this.$router.replace({ path: '/b2b/presellActivityList/presellOrderList' })
                return false
            }
            this.$router.replace({ path: '/b2b/order/orderList' })
        },
        onGroupDetail () {
            this.$router.replace({ path: '/b2b/groupBookActivity/groupDetail', query: { groupParticipationId: this.groupParticipationId } })
        },
        clickHandle () {
            if (this.status == 30 || this.canPayRetainage) {
                localStorage.setItem('orderNum', 1)
            } else {
                localStorage.setItem('orderNum', 0)
            }
            if (this.$route.query.presaleId && !this.canPayRetainage) {
                this.$router.replace({ path: '/b2b/presellActivityList/presellOrderList' })
                return false
            }
            this.$router.replace({ path: '/b2b/order/orderList' })
        },
        activityInfo () {
            this.activityParams.categoryName = 3
            this.setActivity(this.activityParams)
            localStorage.removeItem('spikeData')
        },
        async recommend () {
            const { data } = await getRecommentd({
                skuIds: this.$route.query.skuIds
            })
            this.recommendList = data
        },
        handleDetail (id) {
            localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/goods/goodsDetail', query: { id: id } })
        }
    },
    created () {
        this.activityParams = localStorage.getItem('spikeData') ? JSON.parse(localStorage.getItem('spikeData')) : ''
        this.recommend()
        switch (this.status) {
            case 20:
                this.result = '支付处理中'
                this.url = this.peddingUrl
                break
            case 30:
                this.result = '支付成功'
                this.url = this.successUrl
                if (this.spikeId) {
                    this.activityInfo()
                }
                break
            case 40:
                this.result = '支付失败'
                this.url = this.failUrl
                break
            default:
                this.result = '系统异常'
        }
    }
}
</script>

<style lang="scss" scoped>
.auditResult {
    height: 100%;
    background: #fff;
}
.body {
    height: auto;
    padding-top: 120px;
    text-align: center;
    background: #fff;
    img {
        width: 144px;
        height: 144px;
    }
    .result {
        color: #000000;
        font-size: 36px;
        font-weight: 400;
        margin: 48px 0 16px 0;
    }
    .tips {
        color: #8e8e93;
        font-size: 28px;
        font-weight: 400;
    }
    .errtips {
        color: #ff3b30;
        font-size: 28px;
        font-weight: 400;
        margin-bottom: 20px;
    }
    button {
        padding: 26px 0;
        width: 70%;
        color: #ff7a45;
        border: 2px solid #ff7a45;
        border-radius: 40px;
        background-color: #fff;
        margin-top: 40px;
    }
}
.recommend {
    margin: 80px 32px 0;
    border-top: 2px solid #ededf0;
}
</style>